import { useCallback } from 'react';

import { writeToLandingPageCookie } from 'src/lib/cookies';
import * as events from 'src/lib/events';
import { useGetCommonEventAuthAttributes } from 'src/services';
import { useMainActions } from '../store';

export const updateUTMCampaign = ({ utmCampaign, shareDocumentId }) => {
  const newData = {
    utm_campaign: utmCampaign,
    shared_document_id: shareDocumentId,
  };
  writeToLandingPageCookie(newData);
};

const useGetLocalAttributes = () => {
  const mainActions = useMainActions();

  return useCallback(
    () => ({
      projectId: mainActions.getProjectId(),
      shareDocumentId: mainActions.getShareDocumentId(),
    }),
    [mainActions]
  );
};

export const usePageEvents = () => {
  const getCommonAuthAttributes = useGetCommonEventAuthAttributes();
  const getLocalAttributes = useGetLocalAttributes();

  const trackDocumentViewed = useCallback(() => {
    events.trackUserEventNoAuth(events.SHARING.viewedSharedDocument, {
      ...getCommonAuthAttributes(),
      ...getLocalAttributes(),
    });
  }, [getCommonAuthAttributes, getLocalAttributes]);

  const trackSignUpClicked = useCallback(() => {
    events.trackUserEventNoAuth(events.SHARING.sharedSignUpClicked, {
      ...getCommonAuthAttributes(),
      ...getLocalAttributes(),
    });
  }, [getCommonAuthAttributes, getLocalAttributes]);

  const trackShareClicked = useCallback(() => {
    events.trackUserEventNoAuth(events.SHARING.sharedShareClicked, {
      ...getCommonAuthAttributes(),
      ...getLocalAttributes(),
    });
  }, [getCommonAuthAttributes, getLocalAttributes]);

  return {
    trackDocumentViewed,
    trackSignUpClicked,
    trackShareClicked,
  };
};
